import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.for-each.js";
var _jsxFileName = "/var/home/clovis/Documents/Mangane/app/soapbox/components/dropdown_menu.tsx";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.map.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// @ts-expect-error no types
// eslint-disable-next-line import/no-unresolved
import dots from '@tabler/icons/dots.svg';
import classNames from 'classnames';
import { supportsPassiveEvents } from 'detect-passive-events';
import React from 'react';
import { spring } from 'react-motion';
// @ts-ignore: TODO: upgrade react-overlays. v3.1 and above have TS definitions
import Overlay from 'react-overlays/lib/Overlay';
import { withRouter } from 'react-router-dom';
import { IconButton, Counter } from 'soapbox/components/ui';
import SvgIcon from 'soapbox/components/ui/icon/svg-icon';
import Motion from 'soapbox/features/ui/util/optional_motion';
const listenerOptions = supportsPassiveEvents ? {
  passive: true
} : false;
let id = 0;
class DropdownMenu extends React.PureComponent {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      mounted: false
    });
    _defineProperty(this, "node", null);
    _defineProperty(this, "focusedItem", null);
    _defineProperty(this, "handleDocumentClick", e => {
      if (this.node && !this.node.contains(e.target)) {
        this.props.onClose();
      }
    });
    _defineProperty(this, "setRef", c => {
      this.node = c;
    });
    _defineProperty(this, "setFocusRef", c => {
      this.focusedItem = c;
    });
    _defineProperty(this, "handleKeyDown", e => {
      if (!this.node) return;
      const items = Array.from(this.node.getElementsByTagName('a'));
      const index = items.indexOf(document.activeElement);
      let element = null;
      switch (e.key) {
        case 'ArrowDown':
          element = items[index + 1] || items[0];
          break;
        case 'ArrowUp':
          element = items[index - 1] || items[items.length - 1];
          break;
        case 'Tab':
          if (e.shiftKey) {
            element = items[index - 1] || items[items.length - 1];
          } else {
            element = items[index + 1] || items[0];
          }
          break;
        case 'Home':
          element = items[0];
          break;
        case 'End':
          element = items[items.length - 1];
          break;
        case 'Escape':
          this.props.onClose();
          break;
      }
      if (element) {
        element.focus();
        e.preventDefault();
        e.stopPropagation();
      }
    });
    _defineProperty(this, "handleItemKeyPress", e => {
      if (e.key === 'Enter' || e.key === ' ') {
        this.handleClick(e);
      }
    });
    _defineProperty(this, "handleClick", e => {
      const i = Number(e.currentTarget.getAttribute('data-index'));
      const item = this.props.items[i];
      if (!item) return;
      const {
        action,
        to
      } = item;
      this.props.onClose();
      if (typeof action === 'function') {
        e.preventDefault();
        action(e);
      } else if (to) {
        e.preventDefault();
        this.props.history.push(to);
      }
    });
    _defineProperty(this, "handleMiddleClick", e => {
      const i = Number(e.currentTarget.getAttribute('data-index'));
      const item = this.props.items[i];
      if (!item) return;
      const {
        middleClick
      } = item;
      this.props.onClose();
      if (e.button === 1 && typeof middleClick === 'function') {
        e.preventDefault();
        middleClick(e);
      }
    });
    _defineProperty(this, "handleAuxClick", e => {
      if (e.button === 1) {
        this.handleMiddleClick(e);
      }
    });
  }
  componentDidMount() {
    document.addEventListener('click', this.handleDocumentClick, false);
    document.addEventListener('keydown', this.handleKeyDown, false);
    document.addEventListener('touchend', this.handleDocumentClick, listenerOptions);
    if (this.focusedItem && this.props.openedViaKeyboard) {
      this.focusedItem.focus({
        preventScroll: true
      });
    }
    this.setState({
      mounted: true
    });
  }
  componentWillUnmount() {
    document.removeEventListener('click', this.handleDocumentClick);
    document.removeEventListener('keydown', this.handleKeyDown);
    document.removeEventListener('touchend', this.handleDocumentClick);
  }
  renderItem(option, i) {
    if (option === null) {
      return /*#__PURE__*/React.createElement("li", {
        key: `sep-${i}`,
        className: "dropdown-menu__separator",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 181,
          columnNumber: 14
        }
      });
    }
    const {
      text,
      href,
      to,
      newTab,
      isLogout,
      icon,
      count,
      destructive,
      disabled
    } = option;
    return /*#__PURE__*/React.createElement("li", {
      className: classNames('dropdown-menu__item truncate', {
        destructive,
        'opacity-40': disabled
      }),
      key: `${text}-${i}`,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 187,
        columnNumber: 7
      }
    }, /*#__PURE__*/React.createElement("a", {
      className: classNames('text-gray-700 dark:text-gray-400', {
        'hover:bg-gray-100 dark:hover:bg-slate-800 focus:bg-gray-100 dark:focus:bg-slate-800': !disabled
      }),
      "aria-disabled": disabled,
      href: href || to || '#',
      role: "button",
      tabIndex: 0,
      ref: i === 0 ? this.setFocusRef : null,
      onClick: !disabled ? this.handleClick : e => e.preventDefault(),
      onAuxClick: !disabled ? this.handleAuxClick : e => e.preventDefault(),
      onKeyPress: !disabled ? this.handleItemKeyPress : e => e.preventDefault(),
      "data-index": i,
      target: newTab ? '_blank' : undefined,
      "data-method": isLogout ? 'delete' : undefined,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 188,
        columnNumber: 9
      }
    }, icon && /*#__PURE__*/React.createElement(SvgIcon, {
      src: icon,
      className: "mr-3 h-5 w-5 flex-none",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 209,
        columnNumber: 20
      }
    }), /*#__PURE__*/React.createElement("span", {
      className: "truncate",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 210,
        columnNumber: 11
      }
    }, text), count ? /*#__PURE__*/React.createElement("span", {
      className: "ml-auto h-5 w-5 flex-none",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 212,
        columnNumber: 13
      }
    }, /*#__PURE__*/React.createElement(Counter, {
      count: count,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 213,
        columnNumber: 15
      }
    })) : null));
  }
  render() {
    const {
      items,
      style,
      placement,
      arrowOffsetLeft,
      arrowOffsetTop
    } = this.props;
    const {
      mounted
    } = this.state;
    return /*#__PURE__*/React.createElement(Motion, {
      defaultStyle: {
        opacity: 0,
        scaleX: 1,
        scaleY: 1
      },
      style: {
        opacity: spring(1, {
          damping: 35,
          stiffness: 400
        }),
        scaleX: spring(1, {
          damping: 35,
          stiffness: 400
        }),
        scaleY: spring(1, {
          damping: 35,
          stiffness: 400
        })
      },
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 225,
        columnNumber: 7
      }
    }, ({
      opacity,
      scaleX,
      scaleY
    }) =>
    /*#__PURE__*/
    // It should not be transformed when mounting because the resulting
    // size will be used to determine the coordinate of the menu by
    // react-overlays
    React.createElement("div", {
      className: `dropdown-menu ${placement}`,
      style: _objectSpread(_objectSpread({}, style), {}, {
        opacity: opacity,
        transform: mounted ? `scale(${scaleX}, ${scaleY})` : undefined
      }),
      ref: this.setRef,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 230,
        columnNumber: 11
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: `dropdown-menu__arrow ${placement}`,
      style: {
        left: arrowOffsetLeft,
        top: arrowOffsetTop
      },
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 231,
        columnNumber: 13
      }
    }), /*#__PURE__*/React.createElement("ul", {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 232,
        columnNumber: 13
      }
    }, items.map((option, i) => this.renderItem(option, i)))));
  }
}
_defineProperty(DropdownMenu, "defaultProps", {
  style: {},
  placement: 'bottom'
});
const RouterDropdownMenu = withRouter(DropdownMenu);
class Dropdown extends React.PureComponent {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      id: id++,
      open: false
    });
    _defineProperty(this, "target", null);
    _defineProperty(this, "activeElement", null);
    _defineProperty(this, "handleClick", e => {
      const {
        onOpen,
        onShiftClick,
        openDropdownId
      } = this.props;
      e.stopPropagation();
      if (onShiftClick && e.shiftKey) {
        e.preventDefault();
        onShiftClick(e);
      } else if (this.state.id === openDropdownId) {
        this.handleClose();
      } else if (onOpen) {
        const {
          top
        } = e.currentTarget.getBoundingClientRect();
        const placement = top * 2 < innerHeight ? 'bottom' : 'top';
        onOpen(this.state.id, this.handleItemClick, placement, e.type !== 'click');
      }
    });
    _defineProperty(this, "handleClose", () => {
      if (this.activeElement && this.activeElement === this.target) {
        this.activeElement.focus();
        this.activeElement = null;
      }
      if (this.props.onClose) {
        this.props.onClose(this.state.id);
      }
    });
    _defineProperty(this, "handleMouseDown", () => {
      if (!this.state.open) {
        this.activeElement = document.activeElement;
      }
    });
    _defineProperty(this, "handleButtonKeyDown", e => {
      switch (e.key) {
        case ' ':
        case 'Enter':
          this.handleMouseDown(e);
          break;
      }
    });
    _defineProperty(this, "handleKeyPress", e => {
      switch (e.key) {
        case ' ':
        case 'Enter':
          this.handleClick(e);
          e.stopPropagation();
          e.preventDefault();
          break;
      }
    });
    _defineProperty(this, "handleItemClick", e => {
      const i = Number(e.currentTarget.getAttribute('data-index'));
      const item = this.props.items[i];
      if (!item) return;
      const {
        action,
        to
      } = item;
      this.handleClose();
      e.preventDefault();
      e.stopPropagation();
      if (typeof action === 'function') {
        action(e);
      } else if (to) {
        this.props.history?.push(to);
      }
    });
    _defineProperty(this, "setTargetRef", c => {
      this.target = c;
    });
    _defineProperty(this, "findTarget", () => {
      return this.target;
    });
    _defineProperty(this, "componentWillUnmount", () => {
      if (this.state.id === this.props.openDropdownId) {
        this.handleClose();
      }
    });
  }
  render() {
    const {
      src = dots,
      items,
      title,
      disabled,
      dropdownPlacement,
      openDropdownId,
      openedViaKeyboard = false,
      pressed,
      text,
      children
    } = this.props;
    const open = this.state.id === openDropdownId;
    return /*#__PURE__*/React.createElement(React.Fragment, null, children ? /*#__PURE__*/React.createElement("button", {
      ref: this.setTargetRef,
      className: "bg-transparent border-0 p-0",
      disabled: disabled,
      onClick: this.handleClick,
      onMouseDown: this.handleMouseDown,
      onKeyDown: this.handleButtonKeyDown,
      onKeyPress: this.handleKeyPress,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 386,
        columnNumber: 11
      }
    }, children) : /*#__PURE__*/React.createElement(IconButton, {
      disabled: disabled,
      className: classNames({
        'text-gray-400 hover:text-gray-600': true,
        'text-gray-600': open
      }),
      title: title,
      src: src,
      "aria-pressed": pressed,
      text: text,
      onClick: this.handleClick,
      onMouseDown: this.handleMouseDown,
      onKeyDown: this.handleButtonKeyDown,
      onKeyPress: this.handleKeyPress,
      ref: this.setTargetRef,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 390,
        columnNumber: 11
      }
    }), /*#__PURE__*/React.createElement(Overlay, {
      show: open,
      placement: dropdownPlacement,
      target: this.findTarget,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 408,
        columnNumber: 9
      }
    }, /*#__PURE__*/React.createElement(RouterDropdownMenu, {
      items: items,
      onClose: this.handleClose,
      openedViaKeyboard: openedViaKeyboard,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 409,
        columnNumber: 11
      }
    })));
  }
}
_defineProperty(Dropdown, "defaultProps", {
  title: 'Menu'
});
export default withRouter(Dropdown);